import * as React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';

import aos from '@src/utils/aos';
import Link from '@src/components/link';
import SimpleSwiper from '@src/components/swiper/simple-swiper';

const styles = require('./index.less');

const OpenBetaHighlights = ({ store }) => {
  store.use();
  return (
    <div className={styles.root}>
      <div className={styles.open}>
        <div className={styles.open_title} {...aos.FADE_DOWN()} />
        <div className={styles.open_swiper} {...aos.FADE_UP()}>
          <div className={styles.swiper_wrap}>
            <div className={styles.swiper_content}>
              <SimpleSwiper params={store.params} key={store.swiperData.length}>
                {store.swiperData.map((item, index) => (
                  <div key={index} className={styles.swiper_item}>
                    <img src={item} alt="" />
                  </div>
                ))}
              </SimpleSwiper>
            </div>
          </div>
          <div className={styles.swiper_btns}>
            <Link className={cx(styles.swiper_btn, styles.swiper_btn_prev)} onClick={() => store.changeSwiper('prev')} {...aos.FADE_RIGHT()} />
            <Link className={cx(styles.swiper_btn, styles.swiper_btn_next)} onClick={() => store.changeSwiper('next')} {...aos.FADE_LEFT()} />
          </div>
          <div className={styles.swiper_pagination}>
            {store.swiperData.map((item, index) => (
              <Link
                key={index}
                className={cx(styles.swiper_pagination_item, index === store.realIndex && styles.active)}
                onClick={() => store.changeSwiper(index)}
              />
            ))}
          </div>
        </div>
        <div className={styles.prize} {...aos.FADE_UP()}>
          <div className={styles.prize_title} />
          <div className={styles.prize_content}>
            <div className={styles.prize_box} data-name="奖励列表">
              {store.prizeList.map((item, index) => {
                return (
                  <div className={styles.prize_item} key={index}>
                    <img src={item.img} alt="" />
                    <div className={styles.prize_name}>{item.title}</div>
                  </div>
                );
              })}
            </div>
            <div className={styles.prize_code}>
              <div className={styles.prize_code_info}>
                <div className={styles.prize_code_left}>
                  {/* <div className={styles.prize_code_title} /> */}
                  <input type="text" className={styles.prize_code_input} value={store.prize_code} disabled />
                </div>
                <Link className={styles.prize_copy} onClick={store.copyCdk} />
              </div>
              <div className={styles.prize_code_tips} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(OpenBetaHighlights);
